import styled from "styled-components";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const StyledToastContainer = styled(ToastContainer)`
  position: absolute;
  top: 67px !important;
  transition: all 0.3s ease-in-out !important;

  .Toastify__toast {
    background: none !important;
    box-shadow: none !important;
    color: inherit !important;
    padding: 0 16px;
    display: flex !important;
    align-items: center;
    font-size: 1.3rem;
  }

  .Toastify__toast-body {
    padding: 0;
  }

  p {
    font-size: 1.4rem;
    font-weight: 400;
    letter-spacing: 0rem;
  }

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
  }
`;

export const CustomToastContainer = () => {
  return <StyledToastContainer transition={Slide} />;
};
